import { render, staticRenderFns } from "./project-tab-permits.vue?vue&type=template&id=830edcc4&scoped=true"
import script from "./project-tab-permits.vue?vue&type=script&lang=ts"
export * from "./project-tab-permits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830edcc4",
  null
  
)

export default component.exports